export interface FieldSetting {
	label: string;
	canonicalNames?: string[];
}

export interface FieldSettingData {
	[field: string]: FieldSetting;
}

export const FIELD_SETTING_DATA: FieldSettingData = {
	name: {
		label: 'Name',
	},
	brand: {
		label: 'Brand',
	},
	color: {
		label: 'Color',
	},
	description: {
		label: 'Description',
	},
	size: {
		label: 'Size',
	},
	is_personal: {
		label: 'Personal',
	},
	quantity: {
		label: 'Quantity',
	},
	quantity_notes: {
		label: 'Quantity Notes',
	},
	unit_price: {
		label: 'Unit Price',
	},
	total_cost: {
		label: 'Total Cost',
	},
	asset_num: {
		label: 'Asset #',
	},
	disposition_notes: {
		label: 'Disposition Notes',
	},
	purchase_info: {
		label: 'Purchase Info',
		canonicalNames: [
			'purchase_type',
			'vendor_id',
			'sku',
			'start_date',
			'end_date',
		],
	},
};
